<template>
  <div>
    <el-button-group v-if="!disabled" style="padding-bottom:10px;">
      <el-button type="primary" size="small" @click="fromLoad('add')">{{$l('btn_doc_add')||'上传文件'}}</el-button>
    </el-button-group>
    <el-table
      ref="table"
      :data="tableData"
      v-loading="loading"
      size="small"
      :height="height"
      style="width: 100%"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :label="$l('table_head_operation'||'操作')"
        width="120"
        align="left"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding:5px;"
            @click="dowloadDoc(scope.row)"
            icon="el-icon-download"
          />
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-edit"
            @click="openDocEdit(scope.row)"
          />
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-delete"
            type="danger"
            @click="delRow(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjFileTypeName"
        :label="$l('label_file_type')||'文档类型'"
        width="80"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjFileDesc"
        :label="$l('label_file_desc')||'文档说明'"
      ></el-table-column>
      <!-- <el-table-column
        align="center"
        header-align="center"
        prop="prjFileStatus"
        label="文档状态"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.prjFileStatus === 'Y' ? 'success' : 'danger'"
          >{{scope.row.prjFileStatusName}}</el-tag>
        </template>
      </el-table-column>-->
      <!-- <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="uploadName"
        label="上传人员"
        min-width="20"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="uploadTime"
        label="上传时间"
        min-width="30"
      ></el-table-column>-->
    </el-table>
    <doc-add ref="docAdd" :params="params" @success="saveSuccess" />
    <doc-edit :visible.sync="docEditVisible" :prjDocCode="docEditPrjDocCode" @reload="() => $emit('submit')" />
  </div>
</template>

<script>
import DocAdd from "../docAdd";
import DocEdit from "../docEdit"
import util from "@/libs/util";
// import { delApi } from '@api/projectManager/infoDoc'
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    params: {
      default: null,
      type: Object,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  components: {
    DocAdd, DocEdit
  },
  data() {
    return {
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      // 选中的数据
      multipleSelection: [],
      //文档说明编辑参数
      docEditPrjDocCode: '',
      docEditVisible: false,
    };
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = "") {
      this.$refs.docAdd.load();
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.$emit("submit");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delRow(val) {
      this.multipleSelection = [val];
      this.del();
    },
    del() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({
          showClose: true,
          message: "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      this.$confirm(this.$l("tips_delete") || "是否删除？", {
        confirmButtonText: this.$l("INDEX.tips_confirm") || "确认",
        cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
        type: "warning",
      })
        .then((_) => {
          this.$api
            .infoDocDelApi({ docList: this.multipleSelection })
            .then((res) => {
              this.$message({
                showClose: true,
                message: this.$l("tips_delete_ok") || "删除成功！",
                type: "success",
              });
              this.$emit("submit");
            });
        })
        .catch(() => {
          this.$refs.table.clearSelection();
          this.multipleSelection = [];
        });
    },
    // 下载文件 row.scmFileUrl
    dowloadDoc(row) {
      this.$api.SYS_FILEDOWNLOAD(row.prjFileCode)
    },
    getTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        "-" +
        hours +
        "-" +
        minutes +
        "-" +
        seconds
      );
    },
    openDocEdit(row){
      this.docEditPrjDocCode = row.prjDocCode
      this.docEditVisible = true
    }
  },
};
</script>
